<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-2">
        Comment pouvez-vous décrire le changement de l’état d’oxydation du réactant vers le produit
        lors de la réaction suivante?
      </p>

      <p class="pl-12 mb-6">
        <v-img style="max-width: 319px" :src="imageHeadName" />
      </p>

      <v-radio-group v-model="inputs.input1" :disabled="!allowEditing" class="mb-n6">
        <v-radio
          v-for="option in options"
          :key="'pt-1-' + option.value"
          class="my-1"
          :value="option.value"
        >
          <template #label>
            <stemble-latex :content="option.text" />
          </template>
        </v-radio>
      </v-radio-group>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import {prefixPublicAsset} from '@/common/plugins/public-asset-plugin';

export default {
  name: 'chemUott1721B_Task33',
  components: {StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        input1: null,
      },
      options: [
        {
          text: 'L’état d’oxydation augmente',
          value: 'augmente',
        },
        {
          text: 'L’état d’oxydation diminue',
          value: 'diminue',
        },
        {
          text: 'Il n’y a aucun changement de l’état d’oxydation',
          value: 'changement',
        },
      ],
    };
  },
  computed: {
    imageHeadName() {
      return prefixPublicAsset('/img/assignments/task33_main.png');
    },
  },
};
</script>
